import { ValueView } from "web/components"
import { isNonEmptyArray } from "web/services/helpers"

export default function Table({ confirmationData }) {
  const hasConfirmationData = isNonEmptyArray(confirmationData)

  const indexForRow = (row, index) => {
    const rowIndex = row[0]?.index
    return rowIndex ? rowIndex : index
  }

  return (
    <div className="mt-3 flex flex-col pb-3">
      <div className="-mx-5 -my-2 overflow-x-auto">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th></th>
                  {hasConfirmationData &&
                    confirmationData[0].map((fieldValue, index) => (
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500"
                        key={index}
                      >
                        {fieldValue.label}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {confirmationData.map((row, index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap px-6 py-4 text-sm">
                      {indexForRow(row, index + 1)}
                    </td>
                    {row.map((fieldValue, index) => (
                      <td
                        className="whitespace-nowrap px-6 py-4 text-sm"
                        key={index}
                      >
                        {fieldValue.error ? (
                          <div
                            className="font-bold text-red-700"
                            key={index}
                            title={fieldValue.error}
                          >
                            <ValueView
                              key={index}
                              value={fieldValue.value_view}
                            />
                          </div>
                        ) : (
                          <ValueView
                            key={index}
                            value={fieldValue.value_view}
                          />
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
